
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!tree_browser";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/home/bitrock/ruby27stack/apps/canvaslms/htdocs/ui/shared/tree-browser-view/jst/TreeBrowser';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<ul role=\"tree\" tabindex=\"0\" activedescendent=\"\" class=\"tree\"\n  aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "folder_browsing_tree_1f00a3ae", "Folder Browsing Tree", options) : helperMissing.call(depth0, "t", "folder_browsing_tree_1f00a3ae", "Folder Browsing Tree", options)))
    + "\"\n></ul>";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';
    brandableCss.loadStylesheet('jst/TreeBrowser', {"new_styles_normal_contrast":{"combinedChecksum":"486bca8feb"},"new_styles_high_contrast":{"combinedChecksum":"3f80f1d2d4"},"responsive_layout_normal_contrast":{"combinedChecksum":"486bca8feb"},"responsive_layout_high_contrast":{"combinedChecksum":"3f80f1d2d4"},"new_styles_normal_contrast_rtl":{"combinedChecksum":"5733fe07d7"},"new_styles_high_contrast_rtl":{"combinedChecksum":"069ef64d42"},"responsive_layout_normal_contrast_rtl":{"combinedChecksum":"5733fe07d7"},"responsive_layout_high_contrast_rtl":{"combinedChecksum":"069ef64d42"}}[brandableCss.getCssVariant()]);
  ;
    export default templates[name];
  